let lastNumber = 0;
export function getSequentialNumber(): number {
  return lastNumber++;
}
